import React from 'react';
import { Grid, Select, MenuItem, Typography, InputBase } from "@material-ui/core";

type Props = {
  pageSize: number;
  changePageSize: (event: React.ChangeEvent<{value: unknown}>) => void;
  pageItems?: number[];
}

const defaultPageItems = [5,10,20,25,50,100];

const PageSizeAction = ({ changePageSize, pageSize, pageItems = defaultPageItems }: Props) => {

  return(
    <>
      <Grid item>
        <Typography display='inline'>
          Count per page:&nbsp;
        </Typography>
      </Grid>
      <Grid item>
        <Select
          value={pageSize}
          onChange={changePageSize}
          MenuProps={{ style: { zIndex: 2147483100 } }}
          input={<InputBase/>}
        >
          {
            pageItems.map((size, index) =>
              <MenuItem key={index} value={size}>
                {size}
              </MenuItem>
            )
          }
        </Select>
        &nbsp;
      </Grid>
    </>
  )
};

export default PageSizeAction;
